import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import api from '../api';

export default function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('verifying');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('invalid');
      return;
    }
    api.get(`/api/auth/verify-email?token=${encodeURIComponent(token)}`)
      .then(() => setStatus('success'))
      .catch(() => setStatus('error'));
  }, [searchParams]);

  return (
    <div className="auth-page">
      <div className="auth-card">
        {status === 'verifying' && <p>Verifying your email…</p>}
        {status === 'success' && (
          <>
            <h2>Email verified!</h2>
            <p>Your email has been confirmed. You can now <Link to="/account">log in</Link>.</p>
          </>
        )}
        {(status === 'error' || status === 'invalid') && (
          <>
            <h2>Verification failed</h2>
            <p>The link is invalid or has expired. Please <Link to="/account">sign up</Link> again or contact support.</p>
          </>
        )}
      </div>
    </div>
  );
}
